module.exports = __webpack_public_path__ + "static/media/guru_logo.cfb57243.JPG";